import Vue from "vue";

export default {
	state: {
		requirementGroups: [],
		requirementGroup: {}
	},
	mutations: {
		setRequirementGroupsOnState(state, requirementGroups) {
			state.requirementGroups = requirementGroups;
		},
		setRequirementGroupOnState(state, requirementGroup) {
			state.requirementGroup = requirementGroup;
		}
	},
	actions: {
		getRequirementGroups({ commit }, config = {}) {
			const { isIframeContext = false } = config;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("requirementGroups", {}, { isIframeContext })
					.then((response) => {
						this.state.loading = false;
						commit("setRequirementGroupsOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getRequirementGroup({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("requirementGroups/" + id)
					.then((response) => {
						this.state.loading = false;
						commit("setRequirementGroupOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		editRequirementGroup(_, requirementGroup) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("requirementGroups/" + requirementGroup.idRequirementGroup, requirementGroup)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		createRequirementGroup(_, requirementGroup) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("requirementGroups", requirementGroup)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		deleteRequirementGroup(_, requirementGroup) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("requirementGroups/" + requirementGroup.idRequirementGroup)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		}
	},
	getters: {
		requirementGroups({ requirementGroups }) {
			return requirementGroups;
		},
		requirementGroup({ requirementGroup }) {
			return requirementGroup;
		}
	}
};
